import React from 'react';

import ReauthTable from './ReauthTable';

export default () => <ReauthTable />;
